import React, { useEffect, useState, useRef } from 'react';
import { notification, Modal, Tooltip, Popover } from 'antd';
import { ReloadOutlined, LinkOutlined } from '@ant-design/icons';
import { CopyOutlinedIcon } from 'assets/icons';
// import { XIcon } from '@heroicons/react/outline';
import Table from 'components/Table';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import './assets/style.css';
import { Breadcrumbs } from '../../components/Atom/breadcumbs';
import { PageHeader } from '../../components/Atom/PageHeader';
import { ResetButton, Button, FilterButton } from '../../components/Atom/Button';
import SearchField from '../../components/Atom/SearchField';
import http from '../../utils/http';
import GeneratePaymentLink from './GeneratePaymentLink';
import { USER_ROLES } from 'utils/constant';
import { useQuery } from 'react-query';
import StatusTag from 'components/Atom/StatusTag';
import { checkUserPermissions, handleDateRangeFormat, convertToStoreTimezone, handleStateByPassData } from 'utils/services';
import { TIMEZONES } from '../../utils/constant';
import Filter from './assets/filter';

const PaymentLinks = () => {
  const [isCopy, setIsCopy] = useState(false);
  const [filterToggle, setFilterToggle] = useState(false);
  const [openLinkModel, setOpenLinkModel] = useState(false);
  const [link, setlink] = useState(null);
  const [recordId, setRecordId] = useState('');
  const [delayTimer, setDelayTimer] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const tableContainerRef = useRef(null);

  const copyToClipboard = async (link) => {
    try {
      await navigator.clipboard.writeText(link);
      setIsCopy(true);
      setTimeout(() => {
        setIsCopy(false);
      }, 1000);
    } catch (err) {}
  };

  const columnsData = [
    {
      title: 'Order Id',
      render: (value) => value?.order_id || '-',
      key: 'order',
    },
    {
      title: 'Link',
      render: (value) => (
        <div className='flex'>
          <Tooltip title={isCopy ? 'Copied' : 'Click to Copy Link'}>
            {/* <CopyOutlined className='copyLink' onClick={() => copyToClipboard(value?.shortUrl)} /> */}
            {/* <Button > */}
            <div className='mt-1 mr-3' onClick={() => copyToClipboard(value?.shortUrl)} style={{ cursor: 'pointer' }}>
              <CopyOutlinedIcon />
            </div>
            {/* </Button> */}
          </Tooltip>
          <a href={value?.shortUrl} className='linkText' target={'_blank'}>
            {value?.shortUrl}
          </a>
        </div>
      ),
      key: 'link',
    },
    {
      title: 'Status',
      render: (value) => <StatusTag tag={value?.status} />,
      key: 'status',
    },
    {
      title: 'Source',
      render: (value) => (value?.source === 'custom-payment-shopify' ? 'Shopify Payment' : 'Custom Payment'),
      key: 'price',
    },
    {
      title: 'Time',
      render: (value) => value?.updatedAt,
      key: 'time',
    },
  ];

  const store = useSelector((state) => state.company.store);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const fetchData = async (queryParams) => {
    try {
      const paramsData = { offset: queryParams?.offset, limit: queryParams?.limit };
      if (queryParams?.search !== '') {
        paramsData['search_key'] = queryParams?.search;
      }
      const formattedData = filtersDataValues(queryParams?.filtersData);
      const params = { ...paramsData, ...formattedData, ...(store?.isSelected && { store_id: store?._id }), xap_request: true };
      const response = await http.get('/public/v1/payment/link', { params });
      const timezone = store?.settings?.timezone || TIMEZONES.PKT;
      const result = await convertToStoreTimezone(response?.data?.data?.docs, timezone);
      response.data.data.docs = result;
      return response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  const { data, refetch, isLoading, isFetching } = useQuery('paymentLinks', () => fetchData(queryParams), {
    enabled: false,
    manual: true,
  });
  const [queryParams, setQueryParams] = useState({
    offset: 0,
    limit: 20,
    search: '',
    currentPage: 1,
  });
  const [trigerApi, setTrigerApi] = useState(true);
  useEffect(() => {
    if (location?.state?.isRedirection && data) {
      setSearch(location?.state?.searchValue);
      setRecordId(location?.state?.id);
      navigate(location.pathname, { replace: true });
      const data = handleStateByPassData(location?.state?.filtersData, true);
      if (!data) {
        refetch();
      }
      setQueryParams(data);
      setTimeout(() => {
        if (tableContainerRef?.current && location?.state?.id) {
          const row = document?.querySelector(`.custom-row-class.highlighted-row`);
          if (row) {
            row?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      }, 10);
      return;
    } else if (location?.state?.isRedirection) {
      navigate(location.pathname, { replace: true });
    }
    refetch();
  }, [trigerApi, store]);
  //  reorder case handling from transaction tab
  const filtersDataValues = (data) => {
    let filtersData = {};
    if (data?.date_range) {
      const timezone = store?.isSelected ? store?.settings?.timezone || TIMEZONES.PKT : null;
      const { start_date, end_date } = handleDateRangeFormat(data?.date_range, timezone);
      filtersData.start_date = start_date;
      filtersData.end_date = end_date;
    }
    filtersData.status = data?.link_status ?? null;
    return filtersData;
  };

  if (location?.state?.order_id && open === false) {
    setOpen(true);
  }
  const getSearch = async (e) => {
    if (e === '' || e == null) {
      notification.error({ message: 'Please enter details for search', placement: 'bottomRight' });
    } else {
      setQueryParams((pre) => ({ ...pre, currentPage: 1, offset: 0, search: e }));
      setTrigerApi(!trigerApi);
    }
  };
  const handlePagePageChange = (page, pageSize) => {
    if (queryParams?.limit !== pageSize) {
      setQueryParams((pre) => ({ ...pre, limit: pageSize, offset: 0, currentPage: 1 }));
      setTrigerApi(!trigerApi);
    } else {
      const countOffset = page * queryParams?.limit - queryParams?.limit;
      setQueryParams((pre) => ({ ...pre, limit: pageSize, offset: countOffset, currentPage: page }));
      setTrigerApi(!trigerApi);
    }
  };
  const handleCloseFilterModel = () => {
    setIsFilterModalOpen(!isFilterModalOpen);
  };
  const handleSearch = (e) => {
    if (delayTimer && e !== '' && e !== null) {
      clearTimeout(delayTimer);
    }
    setSearch(e.target.value.trim());
  };
  const handleOpen = () => {
    setOpen(!open);
    if (location?.state?.order_id) {
      navigate(location.pathname, { replace: true });
    }
  };
  const handleSearchData = () => {
    if (delayTimer) {
      clearTimeout(delayTimer);
    }
    const newTimer = setTimeout(() => {
      handleRefresh();
    }, 1500);
    setDelayTimer(newTimer);
  };
  const handleRefresh = (isRefresh = true) => {
    if (isRefresh) {
      setSearch(null);
    } else {
      setIsFilterModalOpen(false);
    }
    setQueryParams((pre) => ({ ...pre, offset: 0, currentPage: 1, search: '', filtersData: isRefresh ? pre?.filtersData : null }));
    setTrigerApi(!trigerApi);
  };
  const handleFiltersSearch = (data) => {
    setQueryParams((pre) => ({ ...pre, offset: 0, currentPage: 1, filtersData: data }));
    setTrigerApi(!trigerApi);
  };
  const handleGeneratedLink = (e) => {
    if (location?.state?.order_id) {
      navigate(location.pathname, { replace: true });
    }
    handleRefresh();
    setOpen(!open);
    setlink(e);
    setOpenLinkModel(true);
  };
  const filterToggler = () => {
    setFilterToggle(true);
  };
  const handleReset = () => {
    setQueryParams((prev) => ({ ...prev, offset: 0, currentPage: 1, filtersData: {} }));
    setTrigerApi(!trigerApi);
    setIsFilterModalOpen(false);
  };
  const popOverContent = (
    <div className='popOver'>
      <div className='mt-2 mb-3 flex items-centr gap-2'>
        <span style={{ fontWeight: '700', color: '#262626', fontSize: '16px' }}>Filter</span>
        <div className='flex items-center text-[#000000] gap-2 cursor-pointer' onClick={() => handleReset()}>
          <ReloadOutlined style={{ fontSize: '16px' }} />
          <span style={{ color: '#000000', fontSize: '14px', lineHeight: '24px' }}>Reset All</span>
        </div>
      </div>
      <div className='intentFilters'>
        <Filter filterToggler={filterToggler} filtersData={queryParams?.filtersData} onSearch={handleFiltersSearch} handleClose={handleCloseFilterModel} />
      </div>
    </div>
  );
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Payment Links',
      },
    ],
  };
  const handleFileSelectionModel = () => {
    if (store?.isSelected) {
      setOpen(true);
    } else {
      notification.error({
        message: 'Store Selection Required',
        description: 'Please select a store from the drop-down menu above to continue',
        placement: 'bottomRight',
      });
    }
  };
  const handleRowHover = () => {
    setRecordId('');
  };
  return (
    <div style={{ padding: '0px', width: '100%' }}>
      <div className='header-container p-4'>
        <Breadcrumbs {...breadcrumbProps} />
        <div className='headerPage header-mobile'>
          <div>
            <PageHeader label='Payment Links' button={<ResetButton onClick={isFetching ? '' : handleRefresh} loading={isFetching} />} />
          </div>
          <div>
            {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
              <Button className='primaryBtn mr-4 rounded-lg' onClick={handleFileSelectionModel}>
                <span className='text-base'> Generate Link</span>
              </Button>
            )}
          </div>
        </div>
      </div>
      <div className='headerContainer mt-5'>
        <Popover
          content={popOverContent}
          className={isFilterModalOpen ? 'filter-active filterPopover' : filterToggle ? 'text-base activeFilterToggler filterPopover' : 'text-base filterPopover'}
          trigger='click'
          placement='bottomLeft'
          open={isFilterModalOpen}
          destroyTooltipOnHide
          onOpenChange={() => {
            handleCloseFilterModel();
          }}>
          <FilterButton>
            <div className='text-base'>Filter</div>
          </FilterButton>
        </Popover>
        <div className='searchInput headerContainer' style={{ width: '100%' }}>
          <SearchField
            handleOnChange={handleSearch}
            value={search}
            handlePressEnter={getSearch}
            onReset={handleSearchData}
            placeholder={'Search by Link ID, Order ID, Short URL, Email, Phone'}
            loading={!!(isFetching && search)}
            dropdown={{ show: false }}
            enableSearchBtn={true}
          />
        </div>
      </div>
      <br />
      <div className='overflow-x-auto custom-table' ref={tableContainerRef}>
        <Table
          loading={isLoading}
          dataSource={data?.docs}
          columns={columnsData}
          onRow={(record) => {
            return {
              onClick: (event) => {
                const { className } = event?.target;
                if (!className?.includes('table-action-btn')) {
                  navigate(`/paymentlink/${record?._id}`, { state: { record, id: record?._id, filtersData: handleStateByPassData(queryParams), searchValue: search } });
                }
              },
              onMouseEnter: handleRowHover,
              className: `custom-row-class ${recordId === record?._id ? 'highlighted-row' : ''}`,
            };
          }}
          totalLenght={data?.totalDocs}
          pagingation={{ handlePageChange: handlePagePageChange, perPageSize: queryParams?.limit, page: queryParams?.currentPage }}
        />
      </div>
      <Modal className='linkModel' open={openLinkModel} footer={null} onCancel={() => setOpenLinkModel(false)}>
        <div className='linkPanel'>
          <div className='font-semibold text-base mb-6'>Payment Link</div>
          <a href={link} className='linkText' target={'_blank'}>
            {link}
          </a>
          <div className='CopyPanel'>
            <Tooltip title={isCopy ? 'Copied' : 'Click to Copy Link'}>
              <div className='mt-[4.76rem] mr-3' onClick={() => copyToClipboard(link)} style={{ cursor: 'pointer' }}>
                <CopyOutlinedIcon />
              </div>
            </Tooltip>
          </div>
        </div>
      </Modal>
      <Modal trigger='click' /* className='subscription-modal'  */ centered open={open} width={window.innerWidth < 768 ? 350 : 600} footer={null} destroyOnClose onCancel={handleOpen}>
        <div className='mobileVersion'>
          <div className='font-semibold text-base' style={{ marginBottom: '12px' }}>
            <span className='createIcon'>
              <LinkOutlined />
            </span>
          </div>
          <div className='font-semibold text-base' style={{ marginBottom: '12px' }}>
            Generate Payment Link
          </div>
          <GeneratePaymentLink handleOpen={handleOpen} updateState={handleGeneratedLink} />
        </div>
      </Modal>
    </div>
  );
};
export default PaymentLinks;
